module.exports = __webpack_public_path__ + "media/images/onboarding-52f4a8d1d00a634065e35cbf4326f9b3.svg";